<template>
    <div class="animation w-full relative overflow-hidden h-[700px]">
        <div class="border-t border-gray-200 w-full absolute top-[30%]" />
        <div class="border-t border-gray-200 w-full absolute top-[40%]" />
        <div class="border-t border-gray-200 w-full absolute bottom-[30%]" />
        <div class="border-l bg-white-light w-full border-gray-200 h-full absolute left-[80%]" />

        <div class="overlay-left absolute z-20 -left-1 h-full w-[100px]" />
        <div class="overlay-right absolute z-20 -right-1 h-full w-[100px]" />

        <div ref="graph_wrapper" class="overflow-x-visible graph flex flex-row w-full relative z-10 h-full mt-[80px]">
            <div ref="graph" class="w-max h-auto text-blue">
                <Graph class="fill-current" />
            </div>

            <div class="absolute bottom-0 top-0 left-0 right-0 h-[450px] w-[550px]">
                <div class="flex items-center justify-end w-full h-full">
                    <div ref="panels" class="panels relative transition-all ease-in-out" style="opacity: 0">
                        <div ref="panel_left_container" class="panel-left-container">
                            <div ref="panel_left" class="panel-left absolute transition-all ease-in-out duration-700 shadow-xl">
                                <div ref="panel_left_number_holder" class="transition-all ease-in-out" style="opacity: 0">
                                    <GraphNumberHolder class="panel-left-number-holder transition-all ease-in-out">
                                        <p class="panel-left-number text-blue">{{ left_number }}%</p>
                                    </GraphNumberHolder>
                                </div>
                            </div>
                        </div>
                        <div ref="panel_right_container" class="panel-right-container">
                            <div ref="panel_right" class="panel-right absolute transition-all ease-in-out duration-700 shadow-xl">
                                <div ref="panel_right_number_holder" class="transition-all ease-in-out" style="opacity: 0">
                                    <GraphNumberHolder class="panel-right-number-holder transition-all ease-in-out">
                                        <p class="panel-right-number text-blue">{{ right_number }}%</p>
                                    </GraphNumberHolder>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        graphWidth: null,
        currentScroll: 0,
        timeoutFunction: null,
        left_number: null,
        right_number: null
    }),

    props: ['scrollPercentage', 'animationBlurred', 'isMobile'],

    mounted() {
        this.animate();

        // create random numbers between 9 and 120
        this.left_number = Math.floor(Math.random() * (120 - 9 + 1) + 9);
        this.right_number = Math.floor(Math.random() * (120 - 9 + 1) + 9);

        if (this.isMobile === true) {
            this.$refs.panel_left_number_holder.children[0].style.transform = 'matrix(1, 0, 0, 1, 0, 0)';
            this.$refs.panel_right_number_holder.children[0].style.transform = 'matrix(1, 0, 0, 1, 0, 0)';
        }
    },

    beforeUnmount() {
        this.unmount();
    },

    watch: {
        scrollPercentage() {
            if (this.scrollPercentage >= 50) {
                this.$refs.panel_left_number_holder.children[0].style.transform = 'matrix(1, 0, 0, 1, 0, 0)';
                this.$refs.panel_right_number_holder.children[0].style.transform = 'matrix(1, 0, 0, 1, 0, 0)';
                this.$refs.graph.style.color = '#031837';
            } else {
                this.$refs.panel_left_number_holder.children[0].style.transform = 'matrix(1, 0, -1.8, 1, 1, 1)';
                this.$refs.panel_right_number_holder.children[0].style.transform = 'matrix(1, 0, -1.8, 1, 1, 1)';
                this.$refs.graph.style.color = '#353CEE';
            }
        },

        animationBlurred() {
            // hide the panels if the animation is blurred (in background)
            if (this.animationBlurred) {
                this.$refs.panels.style.display = 'none';
            } else {
                this.$refs.panels.style.display = 'block';
            }
        },

        isMobile() {
            // helper function to check if current client is on mobile
            if (this.isMobile === true) {
                this.$refs.panel_left_number_holder.children[0].style.transform = 'matrix(1, 0, 0, 1, 0, 0)';
                this.$refs.panel_right_number_holder.children[0].style.transform = 'matrix(1, 0, 0, 1, 0, 0)';
            }
        }
    },

    methods: {
        animate() {
            // get the graphs complete width
            this.graphWidth = this.$refs.graph.offsetWidth - this.$refs.graph_wrapper.clientWidth;

            // if currentScroll Position is smaller then the whole Graph animate it, else rewind the Animation
            this.currentScroll <= this.graphWidth ? this.animateStep() : this.rewindAnimation();
        },
        animateStep() {
            this.timeoutFunction = setTimeout(() => {
                this.currentScroll += 1;
                this.$refs.graph.style.transform = 'translateX(' + -this.currentScroll + 'px)';

                // animate the panels
                if (this.currentScroll === 0) {
                    this.rewindPanels();
                }
                if (this.currentScroll >= 0 && this.currentScroll < 820) {
                    this.animatePanels(-280);
                }

                // animate the panels
                if (this.currentScroll === 1300) {
                    this.rewindPanels();
                }
                if (this.currentScroll >= 1350) {
                    this.animatePanels(1350);
                }

                // animate the panels
                if (this.currentScroll === 2120) {
                    this.rewindPanels();
                }
                if (this.currentScroll >= 2170) {
                    this.animatePanels(2170);
                }

                this.animate();
            }, 18);
        },
        rewindAnimation() {
            // offset of one iteration
            this.currentScroll = 298;

            // start the animation from the beginning
            this.animate();
        },
        animatePanels(offset = 80) {
            if (this.currentScroll > offset) {
                this.$refs.panels.style.display = 'block';
                this.$refs.panels.style.opacity = '1';
            }
            if (this.currentScroll > offset + 10) {
                this.$refs.panel_left_container.style.top = '245px';
                this.$refs.panel_left_container.style.left = '0px';
                this.$refs.panel_left_container.style.width = '120px';
                this.$refs.panel_left_container.style.height = '70px';

                this.$refs.panel_right_container.style.top = '-165px';
                this.$refs.panel_right_container.style.left = '0px';
                this.$refs.panel_right_container.style.width = '120px';
                this.$refs.panel_right_container.style.height = '70px';
            }
            if (this.currentScroll > offset + 20) {
                this.$refs.panel_left.style.border = '0px solid #FAFCFF';
                this.$refs.panel_left.style.transform = 'matrix(1, 0, 0, 1, 0, 0)';

                this.$refs.panel_right.style.border = '0px solid #FAFCFF';
                this.$refs.panel_right.style.transform = 'matrix(1, 0, 0, 1, 0, 0)';
            }
            if (this.currentScroll > offset + 60) {
                this.$refs.panel_left_number_holder.style.opacity = '1';
                this.$refs.panel_left_container.style.transform = 'translateX(' + -(this.currentScroll - (offset + 40)) + 'px)';
            }
            if (this.currentScroll > offset + 430) {
                this.$refs.panel_right_number_holder.style.opacity = '1';
                this.$refs.panel_right_container.style.transform = 'translateX(' + -(this.currentScroll - (offset + 430)) + 'px)';
            }
        },
        rewindPanels() {
            this.left_number = Math.floor(Math.random() * 121);
            this.right_number = Math.floor(Math.random() * 121);

            this.$refs.panels.style.opacity = '0';
            this.$refs.panels.style.display = 'none';

            this.$refs.panel_left_container.style.transform = 'translateX(0)';
            this.$refs.panel_left.style.border = '3px solid #FAFCFF';
            this.$refs.panel_left.style.transform = 'matrix(-1, -0.58, 0, 0.89, 0, 0)';
            this.$refs.panel_left_container.style.top = '0px';
            this.$refs.panel_left_container.style.left = '0px';
            this.$refs.panel_left_container.style.width = '70px';
            this.$refs.panel_left_container.style.height = '80px';

            this.$refs.panel_right_container.style.transform = 'translateX(0)';
            this.$refs.panel_right.style.border = '3px solid #FAFCFF';
            this.$refs.panel_right.style.transform = 'matrix(1, -0.58, 0, 0.89, 0, 0)';
            this.$refs.panel_right_container.style.top = '15px';
            this.$refs.panel_right_container.style.left = '14px';
            this.$refs.panel_right_container.style.width = '70px';
            this.$refs.panel_right_container.style.height = '80px';

            this.$refs.panel_left_number_holder.style.opacity = '0';
            this.$refs.panel_right_number_holder.style.opacity = '0';
        },
        unmount() {
            clearInterval(this.timeoutFunction);
        }
    }
};
</script>

<style scoped>
.graph::-webkit-scrollbar {
    display: none;
}

.graph {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.panels {
    width: 110px;
    height: 90px;
}

.panels .panel-left {
    transform: matrix(-1, -0.58, 0, 0.89, 0, 0);
    background: linear-gradient(237.2deg, #353cee 24.38%, #6f74f3 47.94%, #353cee 75.79%);
    border: 3px solid #fafcff;
    border-radius: 10px;
    width: 100%;
    height: 100%;
}

.panels .panel-right {
    transform: matrix(1, -0.58, 0, 0.89, 0, 0);
    background: linear-gradient(237.2deg, #031837 24.38%, #374861 47.94%, #031837 75.79%);
    border: 3px solid #fafcff;
    border-radius: 10px;
    width: 100%;
    height: 100%;
}

.panels .panel-left-container {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 70px;
    height: 80px;
    transition:
        top 1s ease 0s,
        left 1s ease 0s,
        width 1s ease 0s,
        height 1s ease 0s;
}

.panels .panel-right-container {
    position: absolute;
    top: 15px;
    left: 40px;
    width: 70px;
    height: 80px;
    transition:
        top 1s ease 0s,
        left 1s ease 0s,
        width 1s ease 0s,
        height 1s ease 0s;
}

.panels .panel-left-number-holder {
    position: absolute;
    top: -50px;
    right: 25px;
    transform: matrix(1, 0, -1.8, 1, 1, 1);
}

.panels .panel-right-number-holder {
    position: absolute;
    top: -50px;
    right: 25px;
    transform: matrix(1, 0, -1.8, 1, 1, 1);
}

.panels .panel-right-number {
    position: absolute;
    top: 10px;
    left: 35px;
}

.panels .panel-left-number {
    position: absolute;
    top: 10px;
    left: 35px;
}
</style>
